import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

// Sprint 2.4 (Enterprise Design System Foundation): generalizes the ad hoc antd Statistic+Card tile
// pattern already used in views/admin/Dashboard.jsx into a reusable, tokenized component. tone drives
// the top accent color (success/warning/error/info/default).
// Sprint 7 (Enterprise Dashboard Modernization): added an optional `icon` prop (an antd Icon `type`
// string) — purely additive/opt-in. Omitting it renders identically to every existing call site
// today; no existing KPI tile was retrofitted with a guessed icon choice this sprint.
const StatCard = ({ label, value, hint, tone, icon }) => (
  <div className={`ent-stat-card${tone ? ` ent-stat-card-${tone}` : ''}`}>
    {/* Candidate Result Display Accuracy phase (28 Aug 2026): a long label (e.g. "Governance
        Decisions Logged") wrapped to 2 lines with nothing to stop it, stretching that card taller
        than its siblings in the row — same defect class as the Post Wise cards, fixed the same way:
        single-line ellipsis truncation (themes.scss) plus the full text still available via the
        native browser tooltip on hover. Guarded to strings only — `label` can also be an icon+text
        node, which `title` wouldn't render sensibly for. */}
    <div className="ent-stat-card-label" title={typeof label === 'string' ? label : undefined}>
      {icon && <Icon type={icon} className="ent-stat-card-icon" />}
      {label}
    </div>
    <div className="ent-stat-card-value">{value}</div>
    {hint && <div className="ent-stat-card-hint">{hint}</div>}
  </div>
);

StatCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  hint: PropTypes.node,
  tone: PropTypes.oneOf(['success', 'warning', 'error', 'info']),
  icon: PropTypes.string
};

export default StatCard;
